import React, { forwardRef, useState, useImperativeHandle } from "react";

import CLOSE from "../../assets/images/Modal/Close.png";

import ImageComponent from "../ImageComponent/ImageComponent";

import "./ModalDialog.scss";

const ModalDialog = forwardRef((props, ref) => {
  const [display, setDisplay] = useState(props.active || false);
  const [actions] = useState(true);

  useImperativeHandle(ref, () => {
    return {
      openModal: () => open(),
      closeModal: () => close(),
    };
  });

  const open = () => {
    setDisplay(true);
  };

  const close = () => {
    setDisplay(false);
    if (props.handleClose) {
      props.handleClose();
    }
  };

  if (display) {
    const classes = ["ModalContainer"];
    const backgroundClasses = ["Background"];
    if (props.className) classes.push(props.className);

    if (!actions) {
      classes.push("disabled");
      backgroundClasses.push("disabled");
    }

    return (
      <div className="ModalDialog">
        <div className={backgroundClasses.join(" ")} onClick={close}></div>
        <div className={classes.join(" ")} style={props.style}>
          <ImageComponent className="CloseButton" url={CLOSE} onClick={close} />
          {props.children}
        </div>
      </div>
    );
  }

  return null;
});
ModalDialog.displayName = "ModalDialog";
export default ModalDialog;
